import api from '../services/apiServices';
import {extractS3Path} from './stripS3Prefix' 

//Single File upload
export const uploadFileToS3 = async (file, folder = "misc", customFilename = null) => {
  // Note: Removed 'token' as it should be handled by your api instance
  try {
    //console.log("📸 In S3file uploader trying to Upload file:", file.name);

    let finalName = file.name;

    if (customFilename) {
      const ext = file.name.split(".").pop();
      // Clean the custom name: lowercase, remove special chars, replace spaces with dashes
      const cleanName = customFilename
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric with dashes
        .replace(/(^-|-$)/g, ""); // Remove leading/trailing dashes

      finalName = `${cleanName}.${ext}`;
    }

    const query = new URLSearchParams({
      filename: finalName,
      folder: folder,
    });

    // CHANGE 1: Directly work with the response from your `api` service
    const res = await api.get(`/admin/upload/get-presigned-surl?${query}`);
    //console.log("📸 Presigned URL response for:", finalName, res);

    // CHANGE 2: Check for a successful status and access the response via `res.data`
    if (res.status !== 200 || !res.data) {
      throw new Error(
        `Presigned URL fetch failed (${res.status}): ${res.statusText}`
      );
    }

    // CHANGE 3: Destructure directly from `res.data`
    const { upload_url, file_url } = res.data;
    if (!upload_url || !file_url) {
      throw new Error("❌ Presigned URL or file URL missing in response data");
    }

    // This part remains the same, as it uses the native fetch API
    const uploadRes = await fetch(upload_url, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
        "Cache-Control": "public, max-age=31536000, immutable",
      },
    });

    if (!uploadRes.ok) {
      const errText = await uploadRes.text();
      throw new Error(`S3 Upload Failed: ${uploadRes.status} — ${errText}`);
    }

    const urlPath = extractS3Path(file_url);
    console.log(`Raw url: ${file_url} Stripped url:${urlPath}`);
    return urlPath; // This will now correctly return the final URL
  } catch (err) {
    console.error(`❌ Upload failed for ${file.name}:`, err.message);
    throw err; // Re-throw to be caught by the calling function in InfoTab.jsx
  }
};
  
  //Multiple Image uploads
  export const uploadMultipleToS3 = async (files, folder, token) => {
    const filenames = files.map((file) => file.name);

    const res = await api.post(
      `/admin/upload/get-presigned-murls`,
      { filenames, folder },
      {
        headers: {
          Authorization: `Bearer ${token}`, // explicitly override if needed
        },
      }
    );

    const { urls } = res.data; // [{ filename, upload_url, file_url }]
    const fileUrlMap = {};

    await Promise.all(
      urls.map(async ({ filename, upload_url, file_url }) => {
        const file = files.find((f) => f.name === filename);
        if (!file) return;

        const uploadRes = await fetch(upload_url, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": file.type,
            "Cache-Control": "public, max-age=31536000, immutable",
          },
        });

        if (uploadRes.ok) {
          fileUrlMap[filename] = extractS3Path(file_url || '');
        }
      })
    );

    return files.map((f) => fileUrlMap[f.name]).filter(Boolean);
  };
